import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramPhoneCallsPage } from './program-phone-calls';

@NgModule({
  declarations: [
    ProgramPhoneCallsPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramPhoneCallsPage),
  ],
})
export class ProgramPhoneCallsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-phone-calls/program-phone-calls.module.ts